import { useState } from "react";

const initial = {
    cleaned: null,
    pickup: null,
    biohazard: null,
    notes: ""
}

const useSetStopQuestions = () => {
    const [details, setDetails] = useState(initial);
    const [completed, setCompleted] = useState(false);

    const onChange = (question) => {
        setDetails(prev => {
            let newValue = { ...prev, ...question };

            if (newValue.cleaned && newValue.pickup && newValue.biohazard) {
                if (newValue.biohazard === "Yes") {
                    if (newValue.notes) {
                        setCompleted(true);
                    }
                    else {
                        setCompleted(false);
                    }
                    return newValue;
                }

                setCompleted(true);
            }

            return newValue;
        });
    }

    const reset = () => {
        setDetails(initial);
        setCompleted(false);
    }

    return [details, completed, onChange, reset];
}

export default useSetStopQuestions;